


import { Component, Prop, Vue } from "vue-property-decorator";
import { Next, Route } from 'vue-router';
import  ButtonVue from "@/lib/Button.vue";

@Component({ async beforeRouteEnter(to: Route, from: Route, next: Next<MenuItemVue>) {
            console.log("beforeRouteEnter:", to.path)
            next((vm: MenuItemVue) => {  })
        },
        components: {  ButtonVue } 
        })
export default class MenuItemVue extends Vue {

  @Prop(Object) data:any;


  show_route(path:string) {
    for (let i=0;i<this.$router.currentRoute.matched.length;i++) {
      const r:any=this.$router.currentRoute.matched[i]
      if (r.regex.keys.length>0) {
        
        let ret=0
        if (r.path==path) ret=2;
        if (path.indexOf(r.path)==0) ret=1;
        console.log("&&&&&&&&&&&&&&&&&&&&&&&&&&&&",r.path, path, path.indexOf(r.path))
        return ret;
      }
    }
    return 0;
  }

  get displayRoute() {

    let ret=true

    let tokens=this.data.path.split("/")
    //console.log("PARAMS ",this.$route.params)
    let tt:string="tokens: "
    

    for (let i=0;i<tokens.length;i++) {
      const token_raw=tokens[i]
      let token_type=""


      if (token_raw.charAt(0)==":") {
        token_type="(param)"
        const token = token_raw.slice(1);
        if (this.$route.params[token]) {
          tt+=token+" found "
        } else {
          tt+=token_raw+" not found "
          ret=false;
        }
      }
      else {
          tt+=token_raw+"  "
      }
    }
    
    

    return ret
  }



 
}
